var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEframeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 60,
    height: 60,
    rx: 5,
    fill: "#f1993c"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 45,
    fontFamily: "Arial",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#333"
  }, "eframe")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEframeLogo);
export default __webpack_public_path__ + "static/media/eframe-logo.eb16e88d52931cffac3b44664ae3c485.svg";
export { ForwardRef as ReactComponent };